<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="订单编号" prop="orderNo">
                <a-input v-model="queryParam.orderNo" :maxLength="32" :placeholder="$t('通用.输入.请输入')+'订单编号'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="任务标题快照" prop="taskTitle">
                <a-input v-model="queryParam.taskTitle" :maxLength="32" :placeholder="$t('通用.输入.请输入')+'任务标题快照'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <template>
              <a-col :md="6" :sm="24">
              <a-form-item label="联系电话" prop="contactPhone">
                <a-input v-model="queryParam.contactPhone" :maxLength="32" :placeholder="$t('通用.输入.请输入')+'联系电话'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="是否预约单" prop="isAppointment">
                <a-select v-model="queryParam.isAppointment" :placeholder="$t('通用.输入.请选择')+'是否预约单'" allow-clear>
                  <a-select-option :value="0">否</a-select-option>
                  <a-select-option :value="1">是</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单状态" prop="orderStatus">
                <a-select v-model="queryParam.orderStatus" :placeholder="$t('通用.输入.请选择')+'订单状态'" allow-clear>
                  <a-select-option :value="0">待支付</a-select-option>
                  <a-select-option :value="1">待服务</a-select-option>
                  <a-select-option :value="2">服务中</a-select-option>
                  <a-select-option :value="3">待确认</a-select-option>
                  <a-select-option :value="4">已完成</a-select-option>
                  <a-select-option :value="5">已取消</a-select-option>
                  <a-select-option :value="6">退款中</a-select-option>
                  <a-select-option :value="7">已退款</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="支付状态" prop="payStatus">
                <a-select v-model="queryParam.payStatus" :placeholder="$t('通用.输入.请选择')+'支付状态'" allow-clear>
                  <a-select-option :value="0">未支付</a-select-option>
                  <a-select-option :value="1">已支付</a-select-option>
                  <a-select-option :value="2">已退款</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('通用.文本.创建时间')" prop="createTimeRange">
                  <a-range-picker 
                    style="width: 100%" 
                    v-model="queryParam.createTimeRange"
                    :show-time="{defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]}"
                    format="YYYY-MM-DD HH:mm:ss"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    allow-clear
                    @change="handleDateChange"
                  />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="24" :sm="24">
              <span class="table-page-search-submitButtons" :style="{ float: 'right', overflow: 'hidden' }">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['task:taskorder:export']">
          <a-icon type="download" />{{$t('通用.按钮.导出')}}
        </a-button>
        <a-button type="primary" @click="showCancelTimeSetting" style="margin-left: 8px">
          <a-icon type="setting" />取消时间设置
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '100%' }"
      >
        <span slot="appointmentTime" slot-scope="text, record">
          {{ parseTime(record.appointmentTime) }}
        </span>
        <span slot="payTime" slot-scope="text, record">
          {{ parseTime(record.payTime) }}
        </span>
        <span slot="receiveTime" slot-scope="text, record">
          {{ parseTime(record.receiveTime) }}
        </span>
        <span slot="finishTime" slot-scope="text, record">
          {{ parseTime(record.finishTime) }}
        </span>
        <span slot="cancelTime" slot-scope="text, record">
          {{ parseTime(record.cancelTime) }}
        </span>
        <span slot="createdAt" slot-scope="text, record">
          {{ parseTime(record.createdAt) }}
        </span>
        <span slot="updatedAt" slot-scope="text, record">
          {{ parseTime(record.updatedAt) }}
        </span>
        <span slot="fullAddress" slot-scope="text, record">
          {{ [record.province, record.city, record.district, record.detailAddress].filter(Boolean).join('') }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['task:taskorder:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['task:taskorder:edit']">
             <a-icon type="edit" />{{$t('通用.按钮.修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['task:taskorder:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['task:taskorder:remove']">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <!-- 取消时间设置弹窗 -->
    <a-modal
      title="取消时间设置"
      :visible="cancelTimeSettingVisible"
      @ok="saveCancelTimeSetting"
      @cancel="cancelTimeSettingCancel"
      okText="确定"
      cancelText="取消"
    >
      <a-form layout="vertical">
        <a-form-item label="客户犹豫期时长（分钟）">
          <a-input-number
            v-model="cancelTimeMinutes"
            :min="1"
            :max="1440"
            style="width: 100%"
            placeholder="请输入分钟数"
          />
          <div style="color: #999; font-size: 12px; margin-top: 5px;">
            设置下单后客户可以无条件取消订单的时间窗口，默认5分钟
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pageTaskOrder,listTaskOrder, delTaskOrder, getCancelTimeSetting, setCancelTimeSetting } from '@/api/task/taskOrder'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'TaskOrder',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 取消时间设置弹窗
      cancelTimeSettingVisible: false,
      cancelTimeMinutes: 5, // 默认5分钟
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        orderNo: undefined,
        taskTitle: undefined,
        isAppointment: undefined,
        contactPhone: undefined,
        orderStatus: undefined,
        payStatus: undefined,
        createTimeRange: [],
        createBeginTime: undefined,
        createEndTime: undefined,
        sortField: 'created_at',
        sortOrder: 'desc',
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          width: '100px',
          ellipsis: true,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '发布人',
          dataIndex: 'publisherName',
          width: '100px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '接单人',
          dataIndex: 'receiverName',
          width: '100px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '任务标题快照',
          dataIndex: 'taskTitle',
          width: '100px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '任务描述快照',
          dataIndex: 'taskDesc',
          width: '100px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单金额',
          dataIndex: 'orderAmount',
          width: '100px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '服务数量',
          dataIndex: 'serviceCount',
          width: '100px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '价格单位',
          dataIndex: 'priceUnit',
          width: '100px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '是否预约单',
          dataIndex: 'isAppointment',
          width: '100px',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            return text ? '是' : '否'
          }
        },
        {
          title: '预约时间',
          dataIndex: 'appointmentTime',
          width: '100px',
          scopedSlots: { customRender: 'appointmentTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '地址',
          dataIndex: 'fullAddress',
          width: '200px',
          scopedSlots: { customRender: 'fullAddress' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '联系人',
          dataIndex: 'contactName',
          width: '100px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '联系电话',
          dataIndex: 'contactPhone',
          width: '100px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          width: '100px',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            const statusMap = {
              '0': '待支付',
              '1': '待服务',
              '2': '服务中',
              '3': '待确认',
              '4': '已完成',
              '5': '已取消',
              '6': '退款中',
              '7': '已退款'
            }
            return statusMap[text] || text
          }
        },
        {
          title: '支付状态',
          dataIndex: 'payStatus',
          width: '100px',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            return text === 0 ? '未支付' : text === 1 ? '已支付' : text === 2 ? '已退款' : text
          }
        },
        {
          title: '支付时间',
          dataIndex: 'payTime',
          width: '100px',
          scopedSlots: { customRender: 'payTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '接单时间',
          dataIndex: 'receiveTime',
          width: '100px',
          scopedSlots: { customRender: 'receiveTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '完成时间',
          dataIndex: 'finishTime',
          width: '100px',
          scopedSlots: { customRender: 'finishTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '取消时间',
          dataIndex: 'cancelTime',
          width: '100px',
          scopedSlots: { customRender: 'cancelTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '取消原因',
          dataIndex: 'cancelReason',
          width: '100px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: '100px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createdAt',
          width: '100px',
          scopedSlots: { customRender: 'createdAt' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '更新时间',
          dataIndex: 'updatedAt',
          width: '100px',
          scopedSlots: { customRender: 'updatedAt' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '180px',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 查询任务订单列表 */
    getList () {
      this.loading = true
     pageTaskOrder(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 日期范围变化处理 */
    handleDateChange (dates, dateStrings) {
      if (dates && dates.length === 2) {
        this.queryParam.createBeginTime = dateStrings[0]
        this.queryParam.createEndTime = dateStrings[1]
      } else {
        this.queryParam.createBeginTime = undefined
        this.queryParam.createEndTime = undefined
      }
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        orderNo: undefined,
        taskTitle: undefined,
        isAppointment: undefined,
        contactPhone: undefined,
        orderStatus: undefined,
        payStatus: undefined,
        createTimeRange: [],
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          return delTaskOrder(that.ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(message,3)
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('task/task/order/export',
            that.queryParam
          , `任务订单_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    /** 显示取消时间设置弹窗 */
    showCancelTimeSetting() {
      this.cancelTimeSettingVisible = true;
      // 这里可以调用API获取当前的取消时间设置
      this.getCancelTimeSetting();
    },
    /** 获取取消时间设置 */
    getCancelTimeSetting() {
      getCancelTimeSetting().then(response => {
        if (response.code === '20001' && response.data) {
          this.cancelTimeMinutes = response.data;
        } else {
          // 如果没有设置，则使用默认值5分钟
          this.cancelTimeMinutes = 5;
        }
      }).catch(() => {
        // 出错时使用默认值
        this.cancelTimeMinutes = 5;
      });
    },
    /** 保存取消时间设置 */
    saveCancelTimeSetting() {
      if (this.cancelTimeMinutes <= 0) {
        this.$message.error('取消时间必须大于0分钟');
        return;
      }
      // 调用API保存设置到Redis
      setCancelTimeSetting({ minutes: this.cancelTimeMinutes }).then(response => {
        if (response.code === '20001') {
          this.$message.success(`取消时间已设置为 ${this.cancelTimeMinutes} 分钟`);
          this.cancelTimeSettingVisible = false;
        } else {
          this.$message.error(response.msg || '设置失败');
        }
      }).catch(error => {
        this.$message.error('设置失败: ' + (error.message || '未知错误'));
      });
    },
    /** 取消设置 */
    cancelTimeSettingCancel() {
      this.cancelTimeSettingVisible = false;
    }
  }
}
</script>
